import { Formik } from "formik";

const StepFour = ({step, nextStep, prevStep, handleFormData, values }) => {
    return (
        <div>
            <div className="border-b-2 py-4">
					<div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">{`Step: ${step} of 6`}</div>
					<div className="flex flex-col md:flex-row md:items-center md:justify-between">
						<div className="flex-1">
							<div>
								<div className="text-md font-bold text-gray-800 leading-tight">S.T.C.W Courses</div>
							</div>
						</div>

						<div className="flex items-center ml-4 md:w-64">
							<div className="w-full bg-white rounded-full mr-2">
								<div className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white" style={{ width: '70%' }}></div>
							</div>
							<div className="text-xs w-10 text-gray-600">70%</div>
						</div>
					</div>
            </div>
			<Formik
			initialValues={{ 
				adv_cert_no: "",
				adv_issue_date: "",
				adv_issue_place: "",
				sas_cert_no: "",
				sas_issue_date: "",
				sas_issue_place: "",
				pssr_cert_no: "",
				pssr_issue_date: "",
				pssr_issue_place: "",
				medical_cert_no: "",
				medical_issue_date: "",
				medical_issue_place: "",
				gmdss_cert_no: "",
				gmdss_issue_date: "",
				gmdss_issue_place: "",
				roc_cert_no: "",
				roc_issue_date: "",
				roc_issue_place: "",
				tasco_cert_no: "",
				tasco_issue_date: "",
				tasco_issue_place: "",
				dc_cert_no: "",
				dc_issue_date: "",
				dc_issue_place: "",
				sso_cert_no: "",
				sso_issue_date: "",
				sso_issue_place: "",
			}}
        validate={values => {
            const errors = {};
            return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
            try{	
            handleFormData(values);
            setSubmitting(false);
            nextStep();
            }catch(e){
                console.log(e)
            }
        }}
        >
        {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
        }) => (
	    <form onSubmit={handleSubmit}>
            <div className="py-10">
            <div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">1. Adv. / Fire Prevention & Fire Fighting</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='adv_cert_no'
											id='adv_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.adv_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='adv_issue_date'
											id='adv_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.adv_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='adv_issue_place'
											id='adv_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.adv_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">2. P.S.C.R.B / P.S.T / S.A.S</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='sas_cert_no'
											id='sas_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sas_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='sas_issue_date'
											id='sas_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sas_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='sas_issue_place'
											id='sas_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sas_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">3. P.S.S.R</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='pssr_cert_no'
											id='pssr_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.pssr_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='pssr_issue_date'
											id='pssr_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.pssr_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='pssr_issue_place'
											id='pssr_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.pssr_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">4. Medical First Aid / Elementary First Aid / Medicare</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='medical_cert_no'
											id='medical_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.medical_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='medical_issue_date'
											id='medical_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.medical_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='medical_issue_place'
											id='medical_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.medical_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">5. G.M.D.S.S</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='gmdss_cert_no'
											id='gmdss_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.gmdss_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='gmdss_issue_date'
											id='gmdss_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.gmdss_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='gmdss_issue_place'
											id='gmdss_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.gmdss_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">6. R.O.C / A.R.P.A / NARAS</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='roc_cert_no'
											id='roc_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.roc_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='roc_issue_date'
											id='roc_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.roc_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='roc_issue_place'
											id='roc_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.roc_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">7. TASCO / Tanker Familiarization</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='tasco_cert_no'
											id='tasco_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.tasco_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='tasco_issue_date'
											id='tasco_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.tasco_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='tasco_issue_place'
											id='tasco_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.tasco_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>

						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">8. D. C. Endorsement (Oil / Chem. Petro)</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='dc_cert_no'
											id='dc_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.dc_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='dc_issue_date'
											id='dc_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.dc_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='dc_issue_place'
											id='dc_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.dc_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>


						<div className="mb-5">
							<div className="grid grid-cols-5 gap-4 border-b-2">
								<div className="col-span-2 sm:col-span-2">
									<div className="mb-5">
										<label className="font-bold mb-1 text-sm text-gray-800 py-6">9. SSO ISPS / STSDSD</label>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="certificate_no" className="font-bold mb-1 text-sm text-gray-800 block">Certificates No</label>
										<input type="text"
											name='sso_cert_no'
											id='sso_cert_no'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sso_cert_no}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your certificate no..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="date_issue" className="font-bold mb-1 text-sm text-gray-800 block">Date of Issue</label>
										<input type="date"
											name='sso_issue_date'
											id='sso_issue_date'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sso_issue_date}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your issue date..."/>
									</div>
								</div>
								<div className="col-span-1 sm:col-span-1">
									<div className="mb-5">
										<label for="place_of_issue" className="font-bold mb-1 text-sm text-gray-800 block">Place of Issue</label>
										<input type="text"
											name='sso_issue_place'
											id='sso_issue_place'
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.sso_issue_place}
											className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
											placeholder="Enter your place of issue..."/>
									</div>
								</div>
							</div>
						</div>
            </div>

            <div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-between">

                    <div className="w-1/2">
						<button
                            onClick={()=> prevStep() }
							className="w-32 focus:outline-none py-2 px-5 rounded-md shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium text-gray-800 text-sm border" 
						>Previous</button>
					</div>

					<div className="w-1/2 text-right">
						<button
							type="submit"
							disabled={isSubmitting}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>Next</button>
					</div>
				</div>
			</div>
            </div>
		</form>)}
		</Formik>
        </div>
    )
}

export default StepFour;